import { render, staticRenderFns } from "./DocumentLibraryConfig.vue?vue&type=template&id=0fc75b90&"
import script from "./DocumentLibraryConfig.vue?vue&type=script&lang=js&"
export * from "./DocumentLibraryConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports